import { render, staticRenderFns } from "./CommentsBoxPopup.vue?vue&type=template&id=40b37bd8&scoped=true&"
import script from "./CommentsBoxPopup.vue?vue&type=script&lang=js&"
export * from "./CommentsBoxPopup.vue?vue&type=script&lang=js&"
import style0 from "./CommentsBoxPopup.vue?vue&type=style&index=0&id=40b37bd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b37bd8",
  null
  
)

export default component.exports